<template>
  <div id="target" v-if="isAdmin">
    <div class="form-row">
      <h3>Email Stage List</h3>
    </div>
    <ejs-grid
      :dataSource="emailStages"
      ref="refEmailStage"
      :created="created"
      :allowSorting="true"
      :allowPaging="true"
      :pageSettings="pageSettings"
      :toolbar="toolbarOptions"
      enablePersistence="true"
      :commandClick="commandClick"
      :allowTextWrap="true"
      :textWrapSettings="wrapSettings"
    >
      <e-columns>
        <e-column headerText="Edit" width="80" textAlign="Left" :commands="commands" />
        <e-column field="stageGroup" headerText="Group" textAlign="Left" width="15%" />
        <e-column field="stage" headerText="Stage" textAlign="Left" width="15%" /><e-column
          field="stageCode"
          headerText="Stage Code"
          textAlign="Left"
          width="12%"
        />
        <e-column field="description" width="20%" headerText="Description" textAlign="Left" />
        <e-column field="subjectLine" headerText="SubjectLine" textAlign="Left" />
        <e-column field="isActive" headerText="Is Active" textAlign="Left" />
        <!-- <e-column
          field="emailTemplate"
          width="40%"
          :disableHtmlEncode="false"
          clipMode="EllipsisWithTooltip"
          headerText="Email Template"
          textAlign="Left"
        /> -->
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
import Vue from "vue";
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from "@syncfusion/ej2-vue-grids";
import { mapGetters } from "vuex";
import { FETCH_EMAIL_STAGES } from "../store";

Vue.use(GridPlugin);

export default {
  name: "EmailStageTemplateList",
  data() {
    return {
      commands: [
        {
          type: "Edit",
          buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
        },
      ],
      toolbarOptions: ["Search"],
      pageSettings: { pageSize: 10 },
      target: "#target",
      wrapSettings: { wrapMode: "Content" },
      isAdmin: false,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: "loggedUser",
      emailStages: "emailStages",
    }),
  },
  watch: {
    loggedUser(loggedUser) {
      this.getEmailStages(loggedUser.roles.map((x) => x.roleName));
    },
  },
  created() {
    if (this.loggedUser) this.getEmailStages(this.loggedUser.roles.map((x) => x.roleName));
  },
  mounted() {
    if (this.$refs.refEmailStage) {
      this.$refs.refEmailStage.ej2Instances.searchSettings.key = "";
    }
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar

      if (this.$refs.refEmailStage) {
        const refEmailStageSearchEle = document.getElementById(
          `${this.$refs.refEmailStage.$el.id}_searchbar`,
        );
        if (refEmailStageSearchEle) {
          refEmailStageSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refEmailStage.$el.id);
          });
        }
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove("e-search-icon");
      clearBtnEle.classList.add("e-clear-icon");

      clearBtnEle.addEventListener("click", () => {
        e.target.value = "";
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount == 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value == "") {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    getEmailStages(roles) {
      this.isAdmin = roles.includes("Admin") || roles.includes("SuperAdmin");
      this.$store.dispatch(FETCH_EMAIL_STAGES);
    },
    commandClick(args) {
      if (args.commandColumn.type === "Edit") {
        this.$router.push(`/email-stage-template-edit/${args.rowData.id}`);
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>

<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
.e-content .e-item {
  font-size: 12px;
  margin: 10px;
  text-align: justify;
}

.info {
  margin: 10px;
  font-weight: bold;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
</style>
